import ReactDOMClient from 'react-dom/client';

import { App } from './app';

const root = ReactDOMClient.createRoot(document.getElementById('app')!);
root.render(<App />);